import { useLocation } from "react-router-dom";

/**
 * Hook to detect product type from current route
 * @returns {string|null} - 'corporate', 'course', or null for legacy behavior
 */
export const useProductContext = () => {
  const location = useLocation();

  // Check if the current pathname contains product identifiers
  if (location.pathname.includes("corporate")) {
    return "corporate";
  }

  if (location.pathname.includes("course")) {
    return "preventive_course";
  }

  if (location.pathname.includes("physio-user")) {
    return "physio_user";
  }

  if (location.pathname.includes("physio")) {
    return "physio_therapist";
  }

  // Return null for legacy routes (/, /login, /register)
  return null;
};

export default useProductContext;
